module.exports = __webpack_public_path__ + "img/Pt_Img@2x.8cd5db00.png";